/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, DEFAULT_SLOT, Provider, useContextProps } from 'react-aria-components';
import { breakpoints } from '../../constants.stylex';
import { CloseStrokeIcon } from '../../icons/close-stroke/close-stroke.icon';
import { $ } from '../../tokens.stylex';
import { DIALOG_SLOTS } from '../dialog/dialog.component';
import { HeadingContext } from '../heading/heading.component';
import { IconButtonContext } from '../icon-button/icon-button.component';

interface DialogBarProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  slot?: string;
  style?: stylex.StyleXStyles;
  /** Whether the content of the bottom bar is stacked. */
  isStacked?: boolean;
}

const DialogBarContext = createContext<ContextValue<DialogBarProps, HTMLDivElement>>({});

const DialogBar = forwardRef((props: DialogBarProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, DialogBarContext);

  const { style, children, slot = DIALOG_SLOTS.TOP_BAR, isStacked = false, ...coreProps } = props;

  return (
    <div
      ref={ref}
      {...stylex.props(
        styles.base,
        slot === DIALOG_SLOTS.TOP_BAR ? variantVariants.top : variantVariants.bottom,
        isStacked && styles.stacked,
        style,
      )}
      {...coreProps}
    >
      <Provider
        values={[
          [HeadingContext, { size: 24 }],
          [
            IconButtonContext,
            {
              slots: {
                [DEFAULT_SLOT]: {},
                [DIALOG_SLOTS.CLOSE]: {
                  size: 32,
                  variant: 'ghost',
                  "aria-label": 'Close',
                  children: <CloseStrokeIcon />,
                  style: closeButtonStyles.base,
                },
              },
            },
          ],
        ]}
      >
        {children}
      </Provider>
    </div>
  );
});

const styles = stylex.create({
  base: {
    backgroundColor: $.surface00,
  },
  stacked: {
    alignItems: 'stretch',
    flexDirection: 'column',
  },
});

const variantVariants = stylex.create({
  top: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 8,
    paddingTop: {
      default: 0,
      [breakpoints.small]: 8,
    },
    width: '100%',
  },
  bottom: {
    gap: 8,
    alignItems: 'center',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 20,
  },
});

const closeButtonStyles = stylex.create({
  base: {
    position: 'absolute',
    right: 10,
    top: 16,
  },
});

export { DialogBar, DialogBarContext, type DialogBarProps };
